module.exports = __webpack_public_path__ + "img/samsung_banner_mobile.a338728.png";